import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { fetchApiWithToken } from '~/api/utils'
import type { CompanyContactReferenceLDResponse } from '~/domains/companies/types'

export const useFetchCompanyContactIds = () => {
  const queryClient = useQueryClient()

  return useCallback(
    async (search: string) => {
      const data = await queryClient.fetchQuery({
        queryKey: ['companies', 'prospection', 'contact-ids', search],
        queryFn: () =>
          fetchApiWithToken<CompanyContactReferenceLDResponse>({
            method: 'get',
            url: `/v1/companies/prospection/contact-ids?${search}`,
            useLDJson: true
          }),
        staleTime: 60_000
      })

      return data['hydra:member']
    },
    [queryClient]
  )
}
